import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from './shop/ProductCard';
import './ProductBlock.css';

const ProductBlock = ({ 
  title, 
  description, 
  buttonText = "Ver todos los productos", 
  buttonTo = '/shop',
  products = [] 
}) => {
  return (
    <section className="product-block">
      <div className="product-block-header">
        <h2 className="product-block-title">{title}</h2>
        {description && (
          <p className="product-block-description">{description}</p>
        )}
        <Link to={buttonTo} className="product-block-button">
          {buttonText}
        </Link>
      </div>
      
      <div className="product-block-grid">
        {products.map((product) => (
          <ProductCard 
            key={product.id} 
            product={product} 
          />
        ))}
      </div>
    </section>
  );
};

export default ProductBlock;